import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'

export default function EditStaff() {
    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)
    const [departments, setDepartments] = useState([])
    const [existingAdmins, setExistingAdmins] = useState([])
    const [existingBranches, setExistingBranches] = useState([])
    const [existingStaffs, setExistingStaffs] = useState([])

    const [formData, setFormData] = useState({
        first_name:'',
        last_name:'',
        age:'',
        dob:'',
        aadhaar_no:'',
        address:'',
        gender:'',
        email:'',
        phone:'',
        role:'',
        department:'',
    })

    const [errors, setErrors] = useState({
        first_name:'',
        last_name:'',
        age:'',
        dob:'',
        aadhaar_no:'',
        address:'',
        gender:'',
        email:'',
        phone:'',
        role:'',
        department:'',
    })

    const fetchStaff = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_staffs/`,{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Staffs:', res.data)

            if(res.status === 200){
                const selectedStaff = res.data.data.find((item) => String(item.id) === String(id))

                if(selectedStaff){
                    setFormData({
                        first_name:selectedStaff.first_name || '',
                        last_name:selectedStaff.last_name || '',
                        age:selectedStaff.age?.toString() || '',
                        dob:selectedStaff.dob || '',
                        aadhaar_no:selectedStaff.aadhaar_no || '',
                        address:selectedStaff.address || '',
                        gender:selectedStaff.gender || '',
                        email:selectedStaff.email || '',
                        phone:selectedStaff.phone || '',
                        role:selectedStaff.role || '',
                        department:selectedStaff.department?.toString() || '',
                    })
                }else{
                    toast.error('Staff Not Found')
                    navigate('/admin/all_staffs')
                }
            }
        }catch(error){
            console.log('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to create branch'

            toast.error(message)
        }
    }

    useEffect(() => {
        if(id){
            fetchStaff()
        }
    },[id, token, navigate])

    const fetchDepartments = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_departments/`,{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Departments:', res.data)

            if(res.status === 200){
                setDepartments(res.data.data)
            }else{
                toast.error('Fails to fetch  department data')
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch department'

            toast.error(message)
        }
    }

    useEffect(() => {
        fetchDepartments()
    },[token])

    useEffect(() => {
    const fetchExistingData = async () => {
        try {
        const headers = {
            Authorization: `Token ${token}`
        }

        const [
            adminsResponse,
            branchesResponse,
            staffsResponse
        ] = await Promise.all([
            axios.get(
            `${config.baseurl}get_all_admins/`,
            { headers }
            ),
            axios.get(
            `${config.baseurl}get_all_branches/`,
            { headers }
            ),
            axios.get(
            `${config.baseurl}get_all_staffs/`,
            { headers }
            )
        ])

        const admins = Array.isArray(adminsResponse.data)
            ? adminsResponse.data
            : adminsResponse.data?.data || []

        const branches = Array.isArray(branchesResponse.data)
            ? branchesResponse.data
            : branchesResponse.data?.data || []

        const staffs = Array.isArray(staffsResponse.data)
            ? staffsResponse.data
            : staffsResponse.data?.data || []

        console.log('Admins:', admins)
        console.log('Branches:', branches)
        console.log('Staffs:', staffs)

        setExistingAdmins(admins)
        setExistingBranches(branches)
        setExistingStaffs(staffs)

        } catch (error) {
        console.error(
            'Failed to fetch existing admins/branches/staff:',
            error.response?.data || error
        )
        }
    }

    if (token) {
        fetchExistingData()
    }
    }, [token])

    const handleChange = (e) => {

        const { name, value } = e.target

        let newValue = value
        let error = ''

        // ============================================================
        // DATE OF BIRTH + AUTOMATIC AGE CALCULATION
        // ============================================================

        if (name === 'dob') {

            let calculatedAge = ''

            if (value) {

                const birthDate = new Date(value)
                const today = new Date()

                calculatedAge =
                    today.getFullYear() -
                    birthDate.getFullYear()

                const monthDifference =
                    today.getMonth() - birthDate.getMonth()

                if (
                    monthDifference < 0 ||
                    (
                        monthDifference === 0 &&
                        today.getDate() < birthDate.getDate()
                    )
                ) {
                    calculatedAge--
                }

                // Prevent invalid/future DOB
                if (calculatedAge < 0) {
                    calculatedAge = ''
                }
            }

            setFormData((prev) => ({
                ...prev,
                dob: value,
                age: calculatedAge
            }))

            setErrors((prev) => ({
                ...prev,
                dob: '',
                age: calculatedAge === '' && value
                    ? 'Invalid Date of Birth'
                    : ''
            }))

            return
        }

        // ============================================================
        // FORMAT PHONE
        // ============================================================

        if (name === 'phone') {
            newValue = value
                .replace(/\D/g, '')
                .slice(0, 10)
        }

        // ============================================================
        // FORMAT AADHAAR
        // ============================================================

        if (name === 'aadhaar_no') {
            newValue = value
                .replace(/\D/g, '')
                .slice(0, 12)
        }

        // ============================================================
        // FORMAT EMAIL
        // ============================================================

        if (name === 'email') {
            newValue = value.replace(/\s/g, '')
        }

        // ============================================================
        // UPDATE FORM DATA
        // ============================================================

        setFormData((prev) => ({
            ...prev,
            [name]: newValue
        }))

        // ============================================================
        // AADHAAR VALIDATION
        // ============================================================

        if (name === 'aadhaar_no') {

            if (newValue) {

                if (newValue.length < 12) {

                    error =
                        'Aadhaar should contain exactly 12 digits'

                } else if (newValue.length === 12) {

                    const aadhaarExists =
                        existingStaffs.some(
                            (staff) =>
                                String(staff.aadhaar_no || '')
                                    .replace(/\D/g, '')
                                    .trim() === newValue
                        )

                    if (aadhaarExists) {
                        error =
                            'Aadhaar number already exists'
                    }
                }
            }
        }

        // ============================================================
        // PHONE VALIDATION
        // ============================================================

        if (name === 'phone') {

            if (newValue) {

                if (!/^\d+$/.test(newValue)) {

                    error =
                        'Phone number must contain only digits'

                } else if (!/^[6-9]/.test(newValue)) {

                    error =
                        'Phone number must start with 6, 7, 8 or 9'

                } else if (newValue.length < 10) {

                    error =
                        'Phone number must contain exactly 10 digits'

                } else {

                    const branchPhoneExists =
                        existingBranches.some(
                            (branch) =>
                                String(branch.phone || '').trim() ===
                                newValue
                        )

                    const adminPhoneExists =
                        existingAdmins.some(
                            (admin) =>
                                String(admin.phone || '').trim() ===
                                newValue
                        )

                    const staffPhoneExists =
                        existingStaffs.some(
                            (staff) =>
                                String(staff.phone || '').trim() ===
                                newValue
                        )

                    if (branchPhoneExists) {

                        error =
                            'This phone number already exists in a Branch'

                    } else if (adminPhoneExists) {

                        error =
                            'This phone number already exists for an Admin'

                    } else if (staffPhoneExists) {

                        error =
                            'This phone number already exists for a Staff'
                    }
                }
            }
        }

        // ============================================================
        // EMAIL VALIDATION
        // ============================================================

        if (name === 'email') {

            if (newValue) {

                if (!newValue.includes('@')) {

                    error = 'Missing @ symbol'

                } else {

                    const parts = newValue.split('@')

                    if (parts.length !== 2) {

                        error =
                            'Email can contain only one @ symbol'

                    } else {

                        const username = parts[0]
                        const domain = parts[1]

                        if (!username) {

                            error =
                                'Username is missing before "@"'

                        } else if (!domain) {

                            error =
                                'Domain name is missing'

                        } else if (!domain.includes('.')) {

                            error =
                                'Missing "dot(.)" after domain name'

                        } else {

                            const allowedDomains = [
                                'gmail.com',
                                'yahoo.com',
                                'hotmail.com',
                                'outlook.com'
                            ]

                            if (
                                !allowedDomains.includes(
                                    domain.toLowerCase()
                                )
                            ) {

                                error =
                                    'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'

                            } else {

                                const email =
                                    newValue.trim().toLowerCase()

                                const branchEmailExists =
                                    existingBranches.some(
                                        (branch) =>
                                            String(branch.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                const adminEmailExists =
                                    existingAdmins.some(
                                        (admin) =>
                                            String(admin.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                const staffEmailExists =
                                    existingStaffs.some(
                                        (staff) =>
                                            String(staff.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                if (branchEmailExists) {

                                    error =
                                        'This email already exists in a Branch'

                                } else if (adminEmailExists) {

                                    error =
                                        'This email already exists for an Admin'

                                } else if (staffEmailExists) {

                                    error =
                                        'This email already exists for a Staff'
                                }
                            }
                        }
                    }
                }
            }
        }

        // ============================================================
        // UPDATE ERROR
        // ============================================================

        setErrors((prev) => ({
            ...prev,
            [name]: error
        }))
    } 

    const validateForm = (data) => {
        const newErrors = {}

        if(!data.first_name.trim()){
            newErrors.first_name = 'First Name is required'
        }

        if(!data.last_name.trim()){
            newErrors.last_name = 'Last Name is required'
        }

        if(!data.age){
            newErrors.age = 'Age is required'
        }

        if(!data.dob.trim()){
            newErrors.dob = 'Date of Birth is required'
        }

        if (!data.aadhaar_no.trim()) {
            newErrors.aadhaar_no = 'Aadhaar number is required'
        } else if (!/^\d+$/.test(data.aadhaar_no)) {
            newErrors.aadhaar_no = 'Aadhaar should contain only digits.'
        } else if (data.aadhaar_no.length !== 12) {
            newErrors.aadhaar_no = 'Aadhaar should contain exactly 12 digits.'
        }

        if(!data.gender.trim()){
            newErrors.gender = 'Gender is required'
        }

        if(!data.address.trim()){
            newErrors.address = 'Address is required'
        }

        // Email
        if (data.email) {
            const email = data.email.trim()

            if (!email.includes('@')) {
                newErrors.email = 'Missing @ Symbol'
            } else {
                const [username, domain] = email.split('@')

                if (!username) {
                    newErrors.email = 'Username is missing before "@".'
                } else if (!domain) {
                    newErrors.email = 'Domain name is missing'
                } else if (!domain.includes('.')) {
                    newErrors.email = 'Missing "dot(.)" after domain name'
                } else {
                    const parts = domain.split('.')
                    const extension = parts.slice(1).join('.')

                    if (!extension) {
                        newErrors.email = 'Domain extension is missing'
                    } else {
                        const allowedDomains = [
                        'gmail.com',
                        'yahoo.com',
                        'hotmail.com',
                        'outlook.com'
                        ]

                        if (!allowedDomains.includes(domain.toLowerCase())) {
                            newErrors.email = 'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                        }
                    }
                }
            }
        }

        // Phone
        if (data.phone) {
            if (!/^\d+$/.test(data.phone)) {
                newErrors.phone = 'Phone number contain only digits'
            } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
                newErrors.phone = 'Phone number must start with 6, 7, 8 or 9 and contain exactly 10 digits'
            }
        }

        if(!data.role.trim()){
            newErrors.role = 'Role is required'
        }

        if(!data.department.trim()){
            newErrors.department = 'Department is required'
        }

        return newErrors
    }

    const handleUpdate = async(e) => {
        e.preventDefault()

        const validationErrors = validateForm(formData)

        setErrors(validationErrors)

        if(Object.keys(validationErrors).length > 0){
            return
        }

        setLoading(true)

        try{
            const payload = {
                first_name:formData.first_name.trim(),
                last_name:formData.last_name.trim(),
                age:Number(formData.age),
                dob:formData.dob.trim(),
                aadhaar_no:formData.aadhaar_no.trim(),
                address:formData.address.trim(),
                gender:formData.gender.trim(),
                email:formData.email.trim(),
                phone:formData.phone.trim(),
                role:formData.role.trim(),
                department:Number(formData.department)
            }
            console.log('Updating Staff Id:', id)
            console.log('Payload:', payload)

            const res = await axios.put(`${config.baseurl}update_staff/${id}/`, payload, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('Sending Data:', formData)

            if(res.status === 200){
                toast.success('Staff Updated Successfully')
                navigate('/admin/all_staffs')
            }else{
                toast.error('Error occured while updating staff')
            }
        }catch(error){
            console.error('Update Staff Error:', error.response?.data)

            const message =
                error.response?.data?.error?.[0] ||
                error.response?.data?.message ||
                'Error occurred'

            toast.error(message)
        }finally{
            setLoading(false)
        }
    }
    
    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <AdminHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6'>
            <div className='items-center justify-between text-center'>
                <h2 className='text-3xl font-bold mb-1'>Edit Staff</h2>
                <p className='mt-2 text-sm text-slate-500'>
                    Update the branch details below
                </p>
            </div>
        </div>

        <div className='max-w-7xl mx-auto px-6 pb-12 justify-between items-center'>
            <div className='mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg'>
                <div className='border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg'>
                    <h2 className='text-lg font-bold'>Staff Registration Form</h2>
                </div>

                <form onSubmit={handleUpdate} className="p-6 md:p-8">
                    <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>

                        {/* First Name */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="first_name"
                                className='mb-2 block text-sm font-semibold'
                            >
                                First Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='first_name'
                                type="text"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.first_name
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.first_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.first_name}</p>
                            )}
                        </div>

                        {/* Last Name */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="last_name"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Last Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='last_name'
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.last_name
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.last_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.last_name}</p>
                            )}
                        </div>

                        {/* Date of Birth */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="dob"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Date of Birth
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='dob'
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.dob
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.dob && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.dob}</p>
                            )}
                        </div>

                        {/* Age */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="age"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Age
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='age'
                                type="number"
                                name="age"
                                value={formData.age}
                                readOnly
                                className={`${inputClass} ${errors.age
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.age && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.age}</p>
                            )}
                        </div>

                        {/* Aadhaar Number */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="aadhaar_no"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Aadhaar Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='aadhaar_no'
                                type="text"
                                name="aadhaar_no"
                                value={formData.aadhaar_no}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.aadhaar_no
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.aadhaar_no && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.aadhaar_no}</p>
                            )}
                        </div>

                        {/* Address */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="address"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id='address'
                                rows={4}
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.address
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.address && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                            )}
                        </div>

                        {/* Gender */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="gender"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Gender
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id='gender'
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className={inputClass}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>

                            {errors.gender && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.gender}</p>
                            )}
                        </div>

                        {/* email */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="email"
                                className='mb-2 block text-sm font-semibold'
                            >
                                email
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='email'
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.email
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.email && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.email}</p>
                            )}
                        </div>

                        {/* Phone Number */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="phone"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Phone Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id='phone'
                                type="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.phone
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            />

                            {errors.phone && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.phone}</p>
                            )}
                        </div>

                        {/* Role */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="role"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Role
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id='role'
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.role
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            >
                                <option value="">Select Role</option>
                                <option value="Manager">Manager</option>
                                <option value="Accountant">Accountant</option>
                                <option value="Telecaller">Telecaller</option>
                            </select>

                            {errors.role && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.role}</p>
                            )}
                        </div>

                        {/* Department */}
                        <div className='md:col-span-2'>
                            <label
                                htmlFor="department"
                                className='mb-2 block text-sm font-semibold'
                            >
                                Department
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <select
                                id='department'
                                name="department"
                                value={formData.department}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.department
                                    ? 'border-red-500 focus:border-red-600'
                                    :''
                                }`}
                            >
                                <option value="">Select Department</option>
                                {departments.map((dept) => (
                                    <option
                                        key={dept.id}
                                        value={dept.id}
                                    >
                                        {dept.department_name}
                                    </option>
                                ))}
                            </select>

                            {errors.department && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.department}</p>
                            )}
                        </div>
                    </div>

                    {/* Submit */}
                    <div className='mt-8 flex flex-col-reversegap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end'>
                        <button
                            type='button'
                            onClick={() => navigate(-1)}
                            disabled={loading}
                            className='rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50'
                        >
                            Cancel
                        </button>

                        <button
                            type='submit'
                            disabled={loading || Object.keys(errors).some(key => errors[key])}
                            className='rounded-xl bg-[#000435] text-white px-6 py-3 text-sm font-semibold transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50'
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}
